export { default } from './TourInformation';
